<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <b-link class="brand-logo">
        <logo />

        <h2 class="brand-text text-primary ml-1">{{ appName }}</h2>
      </b-link>

      <b-navbar-nav class="nav align-items-center ml-auto absolute-locale">
        <locale></locale>
      </b-navbar-nav>

      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img fluid :src="imgUrl" />
        </div>
      </b-col>

      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto text-center">
          <div v-if="!loading">
            <div v-if="verifySuccess">
              <b-img
                fluid
                :src="require('@/assets/images/icons/tick.png')"
                class="w-25 mb-2"
              ></b-img>
              <b-card-title
                title-tag="h2"
                class="text-center font-weight-bold mb-1"
              >
                {{ $t("registerConfirm.title") }}
              </b-card-title>
              <b-card-text class="text-center mb-2">
                {{ $t("registerConfirm.subTitle") }}
              </b-card-text>
              <p class="text-center mt-2">
                <b-link :to="{ name: 'login' }">
                  <feather-icon icon="ChevronLeftIcon" />
                  {{ $t("general.backToLogin") }}
                </b-link>
              </p>
            </div>
            <div v-else>
              <b-img
                fluid
                :src="require('@/assets/images/icons/close.png')"
                class="w-25 mb-2"
              ></b-img>
              <b-card-title
                title-tag="h2"
                class="text-center font-weight-bold mb-1"
              >
                {{ $t("registerConfirm.linkExpired") }}
              </b-card-title>
              <b-card-text class="text-center mb-2">
                {{ $t("registerConfirm.loginToRequestLinkAgain") }}
              </b-card-text>
              <p class="text-center mt-2">
                <b-link :to="{ name: 'login' }">
                  <feather-icon icon="ChevronLeftIcon" />
                  {{ $t("general.backToLogin") }}
                </b-link>
              </p>
            </div>
          </div>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import Logo from "@core/layouts/components/Logo.vue";
import {
  BRow,
  BCol,
  BLink,
  BButton,
  BImg,
  BCardTitle,
  BCardText,
  BNavbarNav,
  BSpinner,
} from "bootstrap-vue";
import store from "@/store/index";
import { $themeConfig } from "@themeConfig";
import Locale from "@/layouts/components/app-navbar/Locale.vue";
import Repository from "@/repositories/RepositoryFactory";
import useJwt from '@/auth/jwt/useJwt';

const RegisterRepository = Repository.get("register");

export default {
  components: {
    BRow,
    BImg,
    BCol,
    BLink,
    BButton,
    BCardText,
    BCardTitle,
    BNavbarNav,
    BSpinner,
    Logo,
    Locale,
  },
  data() {
    return {
      sideImg: require("@/assets/images/pages/register-v2.svg"),
      loading: false,
      verifySuccess: false,
    };
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require("@/assets/images/pages/register-v2-dark.svg");
        return this.sideImg;
      }
      return this.sideImg;
    },
    token() {
      return this.$route.query.token;
    },
  },
  beforeMount() {
    if (!this.token) {
      this.$router.replace({ name: "login" });
    } else {
      this.checkToken();
    }
  },
  methods: {
    checkToken() {
      this.loading = true;
      RegisterRepository.verify({ token: this.token })
        .then((response) => {
          const data = response?.data?.data;
          if (data?.isVerify) {
            this.verifySuccess = true;
            if (data?.merchant) {
              localStorage.setItem(useJwt.jwtConfig.storageUserDataKeyName, JSON.stringify(data.merchant));
              this.$store.commit("profile/UPDATE_PROFILE", data.merchant);
            }
          }
        })
        .catch((error) => {})
        .then(() => {
          this.loading = false;
        });
    },
  },
  setup() {
    const { appName } = $themeConfig.app;
    return {
      appName,
    };
  },
};
/* eslint-disable global-require */
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
